import React, { FC } from 'react';
import { connect } from 'react-redux';

import type { CurrencyCode } from 'app/api/services/site-configs/types';
import type { ReduxState } from 'app/redux/types';

import { Amount } from 'app/design-system/components/Amount';
import selectCurrency from 'app/redux/selectors/сurrency';

import { selectAnyHasLockedState, selectSomeHasError } from '../../selectors/entries';

import styles from './TextWithAmountBar.module.scss';

type StoreProps = {
  currency: CurrencyCode;
  disabled: boolean;
};

type AmountBlockProps = {
  value: number;
  onClick?: () => void;
};

const AmountBlock: FC<StoreProps & AmountBlockProps> = ({
  onClick,
  value,
  currency,
  disabled,
}) => {
  const amountComponent = (
    <Amount value={value}
            className={styles.amount}
            currency={currency} />
  );
  return (
    typeof onClick === 'function' ? (
      <button type="button"
              disabled={disabled}
              data-test="textWithAmountBar-clickableAmount"
              className={styles.button}
              onClick={onClick}>
        {amountComponent}
      </button>
    ) : amountComponent
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => {
  const hasEntriesErrors = selectSomeHasError(state) || selectAnyHasLockedState(state);

  return {
    disabled: hasEntriesErrors,
    currency: selectCurrency(state),
  };
};

export default connect(mapStateToProps)(AmountBlock);
